/**
 * Copyright (C) 2019 Olivier Parisot - All Rights Reserved.
 */

import React, { Component } from 'react';
import './App.css';

import { CustomInput, Modal, ModalBody, Button, Jumbotron, Container, Col, Row } from 'reactstrap';

import { Map, TileLayer, Marker } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';

import LoadingOverlay from 'react-loading-overlay';

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import omnivore from '@mapbox/leaflet-omnivore';

import { geolocated } from "react-geolocated";

import HashMap from 'hashmap';

import RouteModal from './RouteModal.js';

import ColorHelper from './ColorHelper.js';
import DBHelper from './DBHelper.js';

import ReactGA from 'react-ga';

import backgroundImage from "./background.jpg";

import Control from 'react-leaflet-control';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleDoubleRight } from '@fortawesome/free-solid-svg-icons'
import { faFacebook, faTwitter, faPinterest, faInstagram, faReddit } from '@fortawesome/free-brands-svg-icons'

import L from 'leaflet';
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
    iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
    iconUrl: require('leaflet/dist/images/marker-icon.png'),
    shadowUrl: require('leaflet/dist/images/marker-shadow.png')
});


const rootUrl=DBHelper.rootUrl;

const initialZoom=12;
const zoomForDetails=10;


/**
 * App.
 *
 * Author: Olivier Parisot
 */
class App extends Component
{
  /** Map reference. */
  map;

  constructor(props)
  {
    super(props);

    this.state =
    {
      splash: true,
      loading: false,
      errorMsg: null,
      mapBounds: null,
      routesData: null,
      selectedRouteIdx: -1,
      shownRoutesHashmap: null,
      shownStartCircleHashmap: null,
      shownEndCircleHashmap: null,
      selectedBestRoutePath: null,
      selectedRefRoutePath: null,
      selectedPotentialPermaLink: null,
      showScore: false,
      showLegend: false,
      legend: null
    }
  }

  componentDidMount = () =>
  {
    this.loadRoutes();

    ReactGA.initialize(DBHelper.gaKey);
    ReactGA.pageview(window.location.pathname + window.location.search);
  }

  loadRoutes()
  {
    this.setState({loading: true});
    const jsonFn=rootUrl+"resultsDB/db2020.json";
    fetch(jsonFn)
      .then(r =>
      {
        return r.json();
      })
      .then(data =>
      {
        console.info(data.length+" routes loaded!");
        var legendSet=new Set();
        for (var i=0;i<data.length;i++)
        {
          const rt=data[i].refTrack;
          if (!legendSet.has(rt)) legendSet.add(rt);
        }

        this.setState({legend: legendSet, routesData: data, loading: false, shownRoutesHashmap: new HashMap(), shownStartCircleHashmap: new HashMap(), shownEndCircleHashmap: new HashMap()});
        //toast.info("Has open "+jsonFn+" ! ("+data.length+")", {position: toast.POSITION.TOP_LEFT});

        if (window.location.search!=="")
        {
          const idx=Number(window.location.search.split("?id=")[1]);
          console.info(window.location.search+" "+idx);
          this.openModal(idx);
          this.setState({splash: false});
        }
      })
      .catch(error => 
      {
        this.setState({loading: false, errorMsg: "Impossible to open "+jsonFn+" !", shownRoutesHashmap: new HashMap(), shownStartCircleHashmap: new HashMap(), shownEndCircleHashmap: new HashMap()});
        toast.error("Impossible to open "+jsonFn+" ! "+error, {position: toast.POSITION.TOP_LEFT});
      });
  }

  getCenter()
  {
    if (!this.props.isGeolocationAvailable||!this.props.isGeolocationEnabled||!this.props.coords)
    {
      //toast.warning("Geolocalization disabled !", {position: toast.POSITION.TOP_LEFT});
      return [49.811719, 6.093248];
    }
    else 
    {
      //toast.info("Geolocalization enabled !", {position: toast.POSITION.TOP_LEFT});
      return [this.props.coords.latitude,this.props.coords.longitude];
    }
    
  }

  getMapHeight()
  {
    return "97%";
  }

  updateBounds(mapBounds)
  {
    this.setState({mapBounds: mapBounds});

    /*if (this.map!==null&&this.map.leafletElement.getZoom()<=zoomForDetails)
    {
      toast.info("Zoom for more details!", {position: toast.POSITION.TOP_LEFT});
    }*/
  }

  inBounds(lat,lon)
  {
    const currbounds=this.state.mapBounds;
    if (lat>currbounds._northEast.lat) return false;
    if (lat<currbounds._southWest.lat) return false;
    if (lon>currbounds._northEast.lng) return false;
    if (lon<currbounds._southWest.lng) return false;
    return true;
  }

  mouseover = (e) =>
  {
    this.setState({selectedRouteIdx: e.target.options.i}/*,this.updateRoutesTracesStyles()*/);
    
  }

  mouseout = (e) =>
  {
    this.setState({selectedRouteIdx: -1}/*,this.updateRoutesTracesStyles()*/);
  }

  openModal(idx)
  {
    const currRoutesData=this.state.routesData;
    const dbPath=currRoutesData[idx].dbPath;
    console.info("openModal "+dbPath);
    //console.info("potential permaLink -> "+);
    const splitChar=dbPath.includes('/')?"/":"\\";
    const refPath=rootUrl+dbPath.split(splitChar)[0]+"/__refs/"+(dbPath.split(splitChar)[2]).split(".")[0]+"/";  
    //ReactGA.initialize(DBHelper.gaKey);
    ReactGA.modalview(window.location.pathname+window.location.search+dbPath);
    var bestPath=rootUrl+dbPath+'/';
    if (bestPath===this.state.selectedBestRoutePath) bestPath=this.state.selectedBestRoutePath.padEnd(this.state.selectedBestRoutePath.length+1," ");
    this.setState({selectedPotentialPermaLink: window.location+"?id="+idx, selectedBestRoutePath: bestPath.padEnd(bestPath.length+Math.random()*10," "), selectedRefRoutePath: refPath});
  }

  click = (e) =>
  {
    this.openModal(e.target.options.i);
  }

  onEachFeature = (feature, layer) =>
  {
    layer.on({
      mouseover: this.mouseover,
      mouseout: this.mouseout,
      click: this.click
    });
  }

  createRoutesTracesIfNeeded = () =>
  {
    const currRoutesData=this.state.routesData;
    if (currRoutesData!=null)
    {
      for (var i=0;i<currRoutesData.length;i++)
      {
          //if (currRoutesData[i].scStartEnd<75) continue;
      
          if (this.state.shownRoutesHashmap.has(i)) continue;
          
          const lat=currRoutesData[i].coords.split(',')[0];
          const lon=currRoutesData[i].coords.split(',')[1];
          if (!this.inBounds(lat,lon)) continue;
          
          if (this.map.leafletElement.getZoom()<=zoomForDetails)
          {
            L.circleMarker([lat,lon],{radius:1, color: this.getRouteColor(this.state.routesData[i])}).addTo(this.map.leafletElement);
          }
          else
          {
            const currI=i;
            const customLayer=L.geoJson(null, {i: currI, onEachFeature: this.onEachFeature, style: this.getRouteTraceStyle(currI)});
            const gpxUrl=rootUrl+currRoutesData[i].dbPath+"/best.gpx";
            const gpxFeature=omnivore.gpx(gpxUrl,null,customLayer);
            this.map.leafletElement.addLayer(gpxFeature);
            this.state.shownRoutesHashmap.set(i,gpxFeature);
            this.addStartEndOfRoute(i);
          }
      }
      //toast.info(this.state.shownRoutesHashmap.size+" routes loaded!", {position: toast.POSITION.TOP_LEFT});      
    }
  }

  getRouteColor = (route) =>
  {
    return this.state.showScore?ColorHelper.percToColor((route.scFull-80)*5):ColorHelper.stringToColor(route.refTrack);
  }

  getRouteTraceStyle = (idx) =>
  {
    const currSelectedRouteIdx=this.state.selectedRouteIdx;
    const currRoutesData=this.state.routesData;
    const ccolor=this.getRouteColor(currRoutesData[idx]);
    if (idx===currSelectedRouteIdx) return({color: ccolor, weight: 10});
    else
    {
      if (currSelectedRouteIdx===-1) return({color: ccolor, weight: 3});
      else return({color: ccolor, weight: 1});
    }
  }

  getCircleTraceStyle = (idx) =>
  {
    const currSelectedRouteIdx=this.state.selectedRouteIdx;
    const currRoutesData=this.state.routesData;
    const ccolor=this.getRouteColor(currRoutesData[idx]);
    if (idx===currSelectedRouteIdx) return({color: ccolor, radius: 15});
    else
    {
      if (currSelectedRouteIdx===-1) return({color: ccolor, radius: 3});
      else return({color: ccolor, radius: 1});
    }
  }

  addStartEndOfRoute = (idx) =>
  {
    //console.info("zoom "+this.map.leafletElement.getZoom());

    if (this.map.leafletElement.getZoom()<=10) return;

    const currRoutesData=this.state.routesData;
    const jsonFn=rootUrl+currRoutesData[idx].dbPath+"/bestStats.json";
    fetch(jsonFn)
      .then(r =>
      {
        return r.json();
      })
      .then(data =>
      {
        const startCircle=L.circleMarker([data.startLatitude, data.startLongitude], this.getCircleTraceStyle(idx));
        startCircle.addTo(this.map.leafletElement);
        this.state.shownStartCircleHashmap.set(idx,startCircle);
        const endCircle=L.circleMarker([data.endLatitude, data.endLongitude], this.getCircleTraceStyle(idx));
        endCircle.addTo(this.map.leafletElement);
        this.state.shownEndCircleHashmap.set(idx,endCircle);
        //toast.info(JSON.stringify(data), {position: toast.POSITION.TOP_LEFT});
      })
      .catch(error => 
      {
        toast.error("Impossible to open "+jsonFn+" !", {position: toast.POSITION.TOP_LEFT});
      });
  }

  updateRoutesTracesStyles = () =>
  {
    if (this.state.shownRoutesHashmap!==null)
    {
      const getRouteTraceStyle=this.getRouteTraceStyle;
      const getCircleTraceStyle=this.getCircleTraceStyle;
      this.state.shownRoutesHashmap.forEach(function(value,key) 
      {
        value.setStyle(getRouteTraceStyle(key));
      });
      this.state.shownStartCircleHashmap.forEach(function(value,key) 
      {
        value.setStyle(getCircleTraceStyle(key));
      });
      this.state.shownEndCircleHashmap.forEach(function(value,key) 
      {
        value.setStyle(getCircleTraceStyle(key));
      });
      //this.setState({loaded: false});
    }
  }

  showLegend = () =>
  {
    if (!this.state.showLegend) return (<br/>);
    else
    {
      if (this.state.legend!==null)
      {
        var legendtoshow=[];
        for (let val of this.state.legend)
        {
          legendtoshow.push(
            <div style={{textAlign: "left", backgroundColor: "rgba(255,255,255,0.8)", color: ColorHelper.stringToColor(val)}}>
              <small><b>&#8226; {DBHelper.flat?val.split(" ")[0]:val}</b></small>
            </div>
          );
        }
        return legendtoshow;
      }
      else return (<br/>);
    }
  }

  render()
  {
    this.updateRoutesTracesStyles();

    return (
      <div className="App">
        <ToastContainer />                    
        <span className="App-Headband" title="www.forunr.com/2020">&nbsp;&nbsp;&nbsp;&nbsp;{DBHelper.title}&nbsp;</span>
        <section style={{margin: '0 auto', height: '100%', width: '100%'}}>
          <Modal centered={true} toggle={() => {this.setState(prevState => ({splash: !prevState.splash}))}} returnFocusAfterClose={true} backdrop={false} fade={false} size="md" isOpen={this.state.splash}  >
            <ModalBody style={{padding: "0px", margin: "0"}}>
              <Button style={{color: 'white'}} close onClick={()=>this.setState({splash: false})}/>
              <Jumbotron style={{margin: "0", color: 'white', backgroundImage: "url("+backgroundImage+")"}}>
                <h1 className="display-4">{DBHelper.title}</h1>
                <br/>
                <hr style={{borderColor: 'white'}}  />
                <p className="lead">Ready to train for the next most famous running races (10k, halfmarathons, marathons, trails)?</p>
                <p className="lead">Check the map and pass over the routes to highlight the tracks; click on them for more details!</p>
                <p style={{textAlign: "center"}}>
                <Button style={{color: 'white', borderColor: 'rgba(0,0,0,0)', backgroundColor: 'rgba(0,0,0,0)'}} onClick={() => this.setState({ splash: false })}>
                  <FontAwesomeIcon size="5x" icon={faAngleDoubleRight} />
                </Button>
                </p>
                <hr style={{borderColor: 'white'}}  />
                <br/>
                <p className="lead" style={{textAlign: "left"}}>Stay in touch! </p>
                <Container>
                  <Row>
                    <Col><a style={{color: 'white'}} rel="noopener noreferrer" target="_blank" href="https://www.facebook.com/forunrdotcom/"><FontAwesomeIcon size="3x" icon={faFacebook} /></a></Col>
                    <Col><a style={{color: 'white'}} rel="noopener noreferrer" target="_blank" href="https://twitter.com/forunrdotcom"><FontAwesomeIcon size="3x" icon={faTwitter} /></a></Col>
                    <Col><a style={{color: 'white'}} rel="noopener noreferrer" target="_blank" href="https://www.instagram.com/forunr/"><FontAwesomeIcon size="3x" icon={faInstagram} /></a></Col>
                    <Col><a style={{color: 'white'}} rel="noopener noreferrer" target="_blank" href="https://www.pinterest.fr/doopyon/forunrcom/"><FontAwesomeIcon size="3x" icon={faPinterest} /></a></Col>
                    <Col><a style={{color: 'white'}} rel="noopener noreferrer" target="_blank" href="https://www.reddit.com/user/doopyon/"><FontAwesomeIcon size="3x" icon={faReddit} /></a></Col>
                  </Row>
                </Container>
              </Jumbotron>
            </ModalBody>
          </Modal>
          <LoadingOverlay styles={{ spinner: (base) => ({...base,width: '500px','& svg circle': {stroke: 'rgba(0, 0, 255, 0.5)'}})}} active={this.state.loading} spinner text='Loading ...' >
          </LoadingOverlay>
          <Map whenReady={(e)=>{this.updateBounds(e.target.getBounds())}} 
                onMoveEnd={(e)=>{this.updateBounds(e.target.getBounds())}} 
                preferCanvas={true}  
                id='map' 
                ref={map => {this.map = map;}} 
                center={this.getCenter()} 
                style={{margin: '0 auto', minHeight: this.getMapHeight(), width: '100%'}} 
                trackResize={true} 
                zoomAnimation={true}
                zoom={initialZoom} 
                minZoom="7">
              <TileLayer url={DBHelper.tileUrl}  />
              {this.createRoutesTracesIfNeeded()}
              <Marker position={this.getCenter()}></Marker>
              <Control position="bottomright" > 
                {this.showLegend()}
              </Control>
              <Control position="bottomleft" >
                <CustomInput checked={this.state.splash}
                                onChange={(e) => {this.setState({ splash: e.target.checked });}}
                                type="switch" 
                                id="showInfo" 
                                name="showInfoSwitch" 
                                label="Show info&nbsp;&nbsp;" />
                <CustomInput checked={this.state.showScore}
                                onChange={(e) => {this.setState({ showScore: e.target.checked, showLegend: e.target.checked?false:this.state.showLegend  });}}
                                type="switch" 
                                id="colorMode" 
                                name="colorModeSwitch" 
                                label="Show score&nbsp;" />
                <CustomInput checked={this.state.showLegend}
                                onChange={(e) => {this.setState({ showLegend: e.target.checked, showScore: e.target.checked?false:this.state.showScore });}}
                                type="switch" 
                                id="showLegend" 
                                name="showLegendSwitch" 
                                label="Show legend" />
              </Control>
          </Map>
          <RouteModal permaLink={this.state.selectedPotentialPermaLink} bestRoutePath={this.state.selectedBestRoutePath} refRoutePath={this.state.selectedRefRoutePath} />
        </section>
        <footer className="App-footer">
          <span>&copy;Copyright 2019 <a className="App-link" rel="noopener noreferrer" target="_blank" href="https://www.doopyon.org">Olivier Parisot</a> - All Rights Reserved.</span>
        </footer>
      </div>
    );
  }
}

export default geolocated({
    positionOptions: {
        enableHighAccuracy: false,
    }
})(App);
